import React, { FC }                                                     from 'react';
import classNames                                                        from 'classnames';
import { IconProps, Menu, MenuItemProps, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { ClassValue }                                                    from 'classnames/types';
import { MenuItemContainer }                                             from '../../containers/MenuItemContainer';


interface Props {
    listProps?: MenuItemProps,
    isActive?: boolean,
    withIndicator?: boolean,
    menuItemClasses?: ClassValue,
    menuIcon?: SemanticICONS
    menuIconColor?: SemanticCOLORS,
    iconProps?: IconProps,
    labelContainerClasses?: ClassValue,

    onClick?: MenuItemProps['onClick']
}

const defaultProps: Props = {
    listProps:             {},
    isActive:              false,
    withIndicator:         true,
    menuItemClasses:       null,
    menuIcon:              null,
    menuIconColor:         null,
    iconProps:             {},
    labelContainerClasses: null,
}

const MenuItemWithIconAndIndicator: FC<Props> = ( props ) => {

    return (

        <Menu.Item
            { ...props.listProps }
            className={ classNames( props.menuItemClasses ) }
            active={ props.isActive }
            color={ props.isActive ? props.listProps.color ?? 'teal' : null }
            onClick={ props.onClick }>

            <MenuItemContainer
                labelContent={ props.children }
                iconProps={ { name: props.menuIcon, color: props.menuIconColor ?? 'teal', ...props.iconProps } }
                indicatorProps={ { active: props.isActive } }
                withIndicator={ props.withIndicator }
                containerClasses={ classNames( 'padding-sm-right', props.labelContainerClasses ) }
            />

        </Menu.Item>
    );
};

MenuItemWithIconAndIndicator.defaultProps = defaultProps;

export { MenuItemWithIconAndIndicator }
